module.exports = __webpack_public_path__ + "img/logo_nacional.png_color.a48d5fd4.png";